// ============================================================
// MattressTown - MOCK DATA
// All content below is mock/seed data for the frontend teaser.
// Replace with real API data during backend integration.
// ============================================================

import { CATALOG } from "./catalog";
import { EXTRA_CATALOG } from "./extra_catalog";
import { MLILY_CATALOG } from "./mlily_catalog";
import { SERTA_KK_EXTRA_CATALOG } from "./serta_kk_extra_catalog";
import { SPRINGAIR_CATALOG } from "./springair_catalog";
import { CATALOG_2026 } from "./catalog_2026";
import { ADJUSTABLE_CATALOG, FOUNDATIONS_CATALOG } from "./adjustable_catalog";


export const SITE = {
  name: "MattressTown",
  tagline: "Fort Lauderdale's Best Mattress Store",
  logo:
    "/assets/logo.png",
  phone: "(954) 530-9280",
  phoneHref: "tel:+19545309280",
  email: "Mattresstownfl@gmail.com",
  url: "https://www.mymattresstown.com",
  applyUrl: "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=E49AF3ED39BF0B741D1F3F75F23D3F88419C6D89A510A97F&client=American%C2%A0Mattress",
  rating: 5.0,
  reviewCount: 371,
  googleReviewUrl: "https://www.google.com/search?client=safari&rls=en&q=mattress+town+fort+lauderdale&ie=UTF-8&oe=UTF-8#lrd=0x88d9015704612977:0xa4acf428df96776c,1,,,,",
  address: {
    street: "2677 N Federal Hwy",
    city: "Fort Lauderdale",
    state: "FL",
    zip: "33306",
    full: "2677 N Federal Hwy, Fort Lauderdale, FL 33306",
    mapsUrl: "https://maps.app.goo.gl/ALoTASFdnFjzxKBN7",
  },
  hours: [
    { day: "Monday - Friday", time: "10:00 AM - 7:00 PM" },
    { day: "Saturday", time: "11:00 AM - 6:00 PM" },
    { day: "Sunday", time: "11:00 AM - 6:00 PM" },
  ],
  storePhotos: [
    "/assets/mt-store.jpg",
    "/assets/mt-store.jpg",
  ],
};

export const CONFIDENCE = [
  {
    icon: "Truck",
    title: "White Glove Delivery",
    sub: "Professional delivery, set-up & old-mattress removal available",
    to: "/services",
  },
  {
    icon: "ShieldCheck",
    title: "100% Comfort Guarantee",
    sub: "Love your mattress or we'll make it right",
    to: "/services",
  },
  {
    icon: "Tag",
    title: "Price Guarantee",
    sub: "We match honest advertised prices",
    to: "/services",
  },
];

// Homepage "Shop Our Top Brand Sales" - uniform promo cards (real carried brands)
export const TOP_BRAND_SALES = [
  {
    brand: "Beautyrest Black",
    logo: "/brands/beautyrest-black.png",
    image: "https://images.unsplash.com/photo-1552858725-a19e7fcd3ac4?w=700&h=850&fit=crop&q=80",
    accent: "#111111",
    offerSmall: "Fall Sale",
    offer: "Up to $1,000 Off",
    note: "Plus a $300 instant gift on select sets",
    to: "/brands/beautyrest-black",
  },
  {
    brand: "Serta",
    logo: "/brands/serta.png",
    image: "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=700&h=850&fit=crop&q=80",
    accent: "#1b6cb3",
    offerSmall: "Fall Sale",
    offer: "Up to 70% Off",
    note: "Free adjustable base on select styles",
    to: "/brands/serta",
  },
  {
    brand: "Beautyrest",
    logo: "/brands/beautyrest.png",
    image: "https://images.unsplash.com/photo-1601276174812-63280a55656e?w=700&h=850&fit=crop&q=80",
    accent: "#14315e",
    offerSmall: "Fall Sale",
    offer: "Up to 70% Off",
    note: "Individually wrapped coil comfort",
    to: "/brands/beautyrest",
  },
  {
    brand: "Puffy",
    logo: "/brands/puffy.png",
    image: "https://images.unsplash.com/photo-1698746044395-85beb2b04522?w=700&h=850&fit=crop&q=80",
    accent: "#1c74d4",
    offerSmall: "Award-Winning",
    offer: "60-Night Trial",
    note: "America's #1 luxury mattress",
    to: "/brands/puffy",
  },
];

// Homepage "Advanced Support" - adjustable set promo cards
export const ADJUSTABLE_PROMOS = [
  {
    brand: "Adjustable Sets",
    image: "/promos/adjustable-sets.jpg",
    accent: "#D0021B",
    offerSmall: "Mattress + Adjustable Base",
    offer: "Save up to $1,000",
    sub: "On Adjustable Sets",
    note: "Plus a $300 free gift",
    to: "/adjustable-bases",
  },
];

// Auto-rotating homepage hero banners - full-bleed lifestyle + overlaid offer text
export const HERO_SLIDES = [
  {
    image: "/banners/hero-fall-sale-mattresses.webp",
    alt: "Fall Sale - Save up to $1,000 on top brand mattresses at MattressTown.",
    preRendered: true,
    bg: "#111317",
    to: "/mattresses",
  },
  {
    image: "/banners/hero-brb-1000.webp",
    alt: "Beautyrest Black Fall Sale - Up to $1,000 off select mattress and adjustable base sets.",
    preRendered: true,
    bg: "#000000",
    to: "/mattresses?brand=beautyrest-black",
  },
  {
    image: "/banners/hero-serta-fall.webp",
    alt: "Serta Perfect Sleeper X Fall Sale - Save up to $800 on select Serta mattress + baselogic adjustable sets.",
    preRendered: true,
    bg: "#0a2a52",
    to: "/mattresses?brand=serta",
  },
  {
    image: "/banners/hero-worldclass-500.webp",
    alt: "Beautyrest World Class Fall Sale - Save up to $500 on select mattress and adjustable base sets.",
    preRendered: true,
    bg: "#000000",
    to: "/mattresses?line=world-class",
  },
  {
    image: "/banners/hero-beautyrest-100.webp",
    alt: "Beautyrest - 100 years of innovation. 10-year warranty, CertiPUR-US certified, made in the USA, adjustable base compatible.",
    preRendered: true,
    bg: "#141019",
    to: "/mattresses?brand=beautyrest",
  },
  {
    image: "/banners/hero-mlily.webp",
    alt: "MLILY Mattresses - shop the MLILY collection at MattressTown.",
    preRendered: true,
    bg: "#ffffff",
    to: "/mattresses?brand=mlily",
  },
];

export const SHOP_BY_BRAND_EXTRA = [
  { slug: "serta-perfect-sleeper-pro", name: "Serta Perfect Sleeper Pro", to: "/mattresses?line=perfect-sleeper-pro" },
  { slug: "serta-icomfort-pro", name: "Serta iComfort Pro", to: "/mattresses?line=icomfort-pro" },
  { slug: "serta-iseries-nxg", name: "Serta iSeries NXG", to: "/mattresses?line=iseries-nxg" },
];

export const PUFFY_LINEUP = [
  {
    image: "/promos/puffy-cloud.webp",
    name: "Puffy Cloud",
    type: "Memory Foam",
    price: "$449",
    totalValue: "$1,849",
    tagline: "Classic Comfort",
    bullets: [
      "Cloudlike cushioning for every sleep style",
      "Keeps you cool all night with cooling foam",
      "Our best value premium mattress",
    ],
    cta: "Shop Puffy Cloud",
    to: "/products/puffy-mattress-4",
  },
  {
    image: "/promos/puffy-lux.webp",
    name: "Puffy Lux",
    type: "Hybrid",
    price: "$749",
    totalValue: "$2,149",
    tagline: "Best Seller",
    bullets: [
      "Enhanced back support with Contour-Adapt Coils",
      "Cooler, deeper sleep with gel-infused foam",
      "Medium-plush feel for every sleeper",
    ],
    cta: "Shop Puffy Lux",
    to: "/products/puffy-lux-mattress-6",
  },
  {
    image: "/promos/puffy-royal.webp",
    name: "Puffy Royal",
    type: "Hybrid",
    price: "$1,089",
    totalValue: "$2,499",
    tagline: "Premium Choice",
    bullets: [
      "Pressure support across 5 targeted zones",
      "Drier sleep with Premium Blended Wool",
      "Ultra-plush feel for full-body support",
    ],
    cta: "Shop Puffy Royal",
    to: "/products/puffy-royal-mattress",
  },
  {
    image: "/promos/puffy-monarch.webp",
    name: "Puffy Monarch",
    type: "Hybrid",
    price: "$1,949",
    totalValue: "$3,399",
    tagline: "Advanced Luxury",
    bullets: [
      "All-season comfort from alpaca wool",
      "Airy, uplifted feel with responsive latex",
      "Luxury-plush feel for every sleep style",
    ],
    cta: "Shop Puffy Monarch",
    to: "/products/puffy-monarch-mattress-6",
  },
  {
    image: "/promos/puffy-legacy.webp",
    name: "Puffy Legacy",
    type: "Hybrid",
    price: "$4,899",
    totalValue: null,
    tagline: "Handcrafted Luxury",
    bullets: [
      "Hand-tufted with cashmere wool and horsehair",
      "Ultra-responsive support with Talalay latex",
      "Our most advanced luxury mattress",
    ],
    cta: "Shop Puffy Legacy",
    to: "/products/puffy-legacy-mattress-4",
  },
];

export const COLLECTIONS = [
  {
    image: "/promos/coll-beautysleep.webp",
    title: "Our value collection",
    price: "Starting at $229",
    cta: "Shop BeautySleep",
    to: "/mattresses",
  },
  {
    image: "/promos/coll-beautyrest.webp",
    title: "Our signature collection",
    price: "Starting at $699",
    cta: "Shop Beautyrest",
    to: "/mattresses?brand=beautyrest",
  },
  {
    image: "/promos/coll-world-class.webp",
    title: "Our premier collection",
    price: "Starting at $1,399",
    cta: "Shop World Class",
    to: "/mattresses?q=world%20class",
  },
  {
    image: "/promos/coll-black.webp",
    title: "Our luxury collection",
    price: "Starting at $1,749",
    cta: "Shop Black",
    to: "/mattresses?brand=beautyrest-black",
  },
];

export const PROMO_TRIO = [
  {
    image: "/promos/promo2-serta-fall.webp",
    alt: "Serta Perfect Sleeper X Fall Sale - Save up to $800 on select Serta mattress + baselogic adjustable sets.",
    bg: "#0a4a8f",
    to: "/mattresses?brand=serta",
  },
  {
    image: "/promos/promo2-worldclass-fall.webp",
    alt: "Beautyrest World Class Fall Sale - Save up to $500 on select mattress and adjustable base sets.",
    bg: "#4b2a4c",
    to: "/mattresses?line=world-class",
  },
  {
    image: "/promos/promo2-brb-fall.webp",
    alt: "Beautyrest Black Fall Sale - Save up to $1000 on adjustable sets, plus a $300 free gift.",
    bg: "#000000",
    to: "/mattresses?brand=beautyrest-black",
  },
  {
    image: "/promos/promo2-kingkoil-fall.webp",
    alt: "King Koil Fall Sale - Save up to $500 on King Koil mattresses at MattressTown.",
    bg: "#102c64",
    to: "/mattresses?brand=king-koil",
  },
];

// Brand video library (files served from /public/videos). Used on Home (hero) + /videos page.
export const HERO_VIDEO = {
  slug: "beautyrest-black-luxury",
  title: "Beautyrest Black: Where Luxury Meets Innovation",
  subtitle: "Go inside the craftsmanship and technology behind the premium brands we carry.",
  src: "/videos/beautyrest-black-luxury.mp4",
  poster: "/videos/beautyrest-black-luxury.jpg",
};

export const VIDEOS = [
  { slug: "beautyrest-black-luxury", brand: "Beautyrest Black", title: "Where Luxury Meets Innovation", orientation: "landscape", src: "/videos/beautyrest-black-luxury.mp4", poster: "/videos/beautyrest-black-luxury.jpg" },
  { slug: "beautyrest-baselogic", brand: "Beautyrest", title: "baseLogic: Customize Your Comfort", orientation: "landscape", src: "/videos/beautyrest-baselogic.mp4", poster: "/videos/beautyrest-baselogic.jpg" },
  { slug: "kingkoil-dualflex", brand: "King Koil", title: "DualFlex Independent Adjustability", orientation: "portrait", src: "/videos/kingkoil-dualflex.mp4", poster: "/videos/kingkoil-dualflex.jpg" },
  { slug: "kingkoil-dualflex-independent", brand: "King Koil", title: "Uninterrupted Sleep, Together", orientation: "portrait", src: "/videos/kingkoil-dualflex-independent.mp4", poster: "/videos/kingkoil-dualflex-independent.jpg" },
  { slug: "kingkoil-handcrafted-luxury", brand: "King Koil", title: "Handcrafted Luxury", orientation: "portrait", src: "/videos/kingkoil-handcrafted-luxury.mp4", poster: "/videos/kingkoil-handcrafted-luxury.jpg" },
  { slug: "beautyrest-individualized-support", brand: "Beautyrest", title: "Individualized Support", orientation: "portrait", src: "/videos/beautyrest-individualized-support.mp4", poster: "/videos/beautyrest-individualized-support.jpg" },
  { slug: "beautyrest-adjustable-compatible", brand: "Beautyrest", title: "Adjustable Base Compatible", orientation: "portrait", src: "/videos/beautyrest-adjustable-compatible.mp4", poster: "/videos/beautyrest-adjustable-compatible.jpg" },
  { slug: "sleep-prepares-us", brand: "Beautyrest", title: "Sleep Prepares Us", orientation: "portrait", src: "/videos/sleep-prepares-us.mp4", poster: "/videos/sleep-prepares-us.jpg" },
  { slug: "mlily-powercool-sleep-system", brand: "MLILY", title: "PowerCool Sleep System", orientation: "landscape", youtube: "EW1MkYCEViE", poster: "https://i.ytimg.com/vi/EW1MkYCEViE/maxresdefault.jpg" },
  { slug: "serta-iseries-nxg", brand: "Serta", title: "Meet Serta iSeries NXG", orientation: "portrait", youtube: "Hv7FWau37SA", poster: "https://i.ytimg.com/vi/Hv7FWau37SA/oardefault.jpg" },
  { slug: "serta-icomfort-pro", brand: "Serta", title: "Serta iComfort Pro", orientation: "landscape", youtube: "BYZOkFwaMxY", poster: "https://i.ytimg.com/vi/BYZOkFwaMxY/maxresdefault.jpg" },
];

export const ADJUSTABLE_FAQS = [
  { q: "What is an adjustable bed?", a: "An adjustable bed (or adjustable base) is a motorized foundation that raises and lowers the head and foot of your mattress with a remote, so you can sleep, read, watch TV or relax in the most comfortable position." },
  { q: "What are the benefits of an adjustable base?", a: "Elevating your head can ease snoring and acid reflux, raising your legs can improve circulation and reduce swelling, and zero-gravity positioning takes pressure off your lower back. Many bases also add massage, under-bed lighting and USB charging." },
  { q: "Will my mattress work on an adjustable base?", a: "Most memory foam, hybrid and latex mattresses are adjustable-base compatible, including Serta, Beautyrest, King Koil, Puffy and MLILY models. Our team will confirm compatibility for any mattress in our Fort Lauderdale showroom." },
  { q: "What is zero gravity on an adjustable bed?", a: "Zero gravity raises your head and legs slightly above your heart, evenly distributing your weight to relieve pressure on your spine. Most bases have a one-touch zero-gravity preset on the remote." },
  { q: "Do adjustable beds help with snoring?", a: "Yes. Raising the head of the bed a few degrees helps keep airways open, and many bases include an anti-snore preset that does this with one button." },
  { q: "Are adjustable beds good for side sleepers?", a: "Absolutely. A slight head and knee lift can reduce pressure on shoulders and hips, and split-king configurations let each partner choose their own position." },
  { q: "Do I need a split king adjustable base?", a: "A split king uses two Twin XL bases side by side so each partner can adjust their side independently. It is the most popular choice for couples with different sleep preferences." },
  { q: "Do you deliver and set up adjustable bases?", a: "Yes. MattressTown offers same-day delivery, professional set-up and old-mattress removal across Miami-Dade, Broward and Palm Beach counties." },
];

// Brand-grouped collections + sub-collections (client brand list). Used on both mobile & desktop.
const nxgModel = (p) => Number((p.name.match(/NXG (\d{4})/) || [])[1] || 0);
const isMattress = (p) => p.category === "mattresses";

// Homepage collection tiles -> exact product lines (not keyword search)
export const LINES = {
  "perfect-sleeper": { name: "Serta Perfect Sleeper", match: (p) => isMattress(p) && /Serta Perfect Sleeper /.test(p.name) && !/Perfect Sleeper (X|Pro)\b/.test(p.name) },
  "perfect-sleeper-x": { name: "Serta Perfect Sleeper X", match: (p) => isMattress(p) && /Perfect Sleeper X\b/.test(p.name) },
  "perfect-sleeper-pro": { name: "Serta Perfect Sleeper Pro", match: (p) => isMattress(p) && /Perfect Sleeper Pro\b/.test(p.name) },
  icomfort: { name: "Serta iComfort", match: (p) => isMattress(p) && /iComfort\b/.test(p.name) },
  "icomfort-pro": { name: "Serta iComfort Pro", match: (p) => isMattress(p) && /iComfortPro/.test(p.name) },
  "iseries-nxg-hybrid": { name: "Serta iSeries NXG Hybrid", match: (p) => isMattress(p) && /iSeries NXG/.test(p.name) && /Hybrid/.test(p.name), sortKey: nxgModel },
  "iseries-nxg-foam": { name: "Serta iSeries NXG Foam", match: (p) => isMattress(p) && /iSeries NXG/.test(p.name) && /(Memory Foam|All-Foam)/.test(p.name), sortKey: nxgModel },
  "iseries-nxg": { name: "Serta iSeries NXG", match: (p) => isMattress(p) && /iSeries NXG/.test(p.name), sortKey: nxgModel },
  masterpiece: { name: "Masterpiece Handcrafted by Serta", match: (p) => isMattress(p) && /Masterpiece/.test(p.name) },
  beautyrest: { name: "Beautyrest", match: (p) => isMattress(p) && p.brand === "beautyrest" && !/World Class/.test(p.name) },
  "world-class": { name: "Beautyrest World Class", match: (p) => isMattress(p) && /World Class/.test(p.name) },
  "beautyrest-black": { name: "Beautyrest Black", match: (p) => isMattress(p) && p.brand === "beautyrest-black" && !/Hybrid|XCS/.test(p.name) },
  "beautyrest-black-hybrid": { name: "Beautyrest Black Hybrid", match: (p) => isMattress(p) && p.brand === "beautyrest-black" && /Hybrid/.test(p.name) && !/XCS/.test(p.name) },
  "beautyrest-black-xcs": { name: "Beautyrest Black Hybrid XCS", match: (p) => isMattress(p) && /XCS/.test(p.name) },
};

export const MOBILE_COLLECTIONS = [
  {
    brand: "Serta",
    boxes: [
      { image: "/collections/serta-perfect-sleeper.jpg", title: "Perfect Sleeper", subtitle: "Everyday comfort", cta: "Shop Perfect Sleeper", to: "/mattresses?line=perfect-sleeper" },
      { image: "/collections/serta-perfect-sleeper-x.jpg", title: "Perfect Sleeper X", subtitle: "Next-gen cooling", cta: "Shop Perfect Sleeper X", to: "/mattresses?line=perfect-sleeper-x" },
      { image: "/collections/serta-perfect-sleeper-pro.jpg", title: "Perfect Sleeper Pro", subtitle: "Latex hybrid with 5 support zones", cta: "Shop Perfect Sleeper Pro", to: "/mattresses?line=perfect-sleeper-pro" },
      { image: "/collections/serta-icomfort.jpg", title: "iComfort", subtitle: "Cool, adaptive foam", cta: "Shop iComfort", to: "/mattresses?line=icomfort" },
      { image: "/collections/serta-icomfortpro.jpg", title: "iComfort Pro", subtitle: "Premium cooling", cta: "Shop iComfort Pro", to: "/mattresses?line=icomfort-pro" },
      { image: "/collections/serta-iseries-nxg-hybrid.jpg", title: "iSeries NXG - Hybrid", subtitle: "Hybrid cooling support", cta: "Shop iSeries NXG Hybrid", to: "/mattresses?line=iseries-nxg-hybrid" },
      { image: "/collections/serta-iseries-nxg-foam.jpg", title: "iSeries NXG - Foam", subtitle: "All-foam cooling", cta: "Shop iSeries NXG Foam", to: "/mattresses?line=iseries-nxg-foam" },
      { image: "/collections/serta-masterpiece.jpg", title: "Masterpiece", subtitle: "Handcrafted by Serta", cta: "Shop Masterpiece", to: "/mattresses?line=masterpiece" },
    ],
  },
  {
    brand: "Beautyrest",
    boxes: [
      { image: "/collections/beautyrest-signature.jpg", title: "Beautyrest", subtitle: "Our signature collection", cta: "Shop Beautyrest", to: "/mattresses?line=beautyrest" },
      { image: "/collections/beautyrest-world-class.jpg", title: "World Class", subtitle: "Our premier collection", cta: "Shop World Class", to: "/mattresses?line=world-class" },
      { image: "/collections/beautyrest-black.jpg", title: "Beautyrest Black", subtitle: "Our luxury collection", cta: "Shop Beautyrest Black", to: "/mattresses?line=beautyrest-black" },
      { image: "/collections/beautyrest-black-hybrid.jpg", title: "Beautyrest Black Hybrid", subtitle: "Hybrid luxury", cta: "Shop Black Hybrid", to: "/mattresses?line=beautyrest-black-hybrid" },
      { image: "/collections/beautyrest-black-xcs.jpg", title: "Beautyrest Black XCS Hybrid", subtitle: "Advanced cooling hybrid", cta: "Shop Black XCS", to: "/mattresses?line=beautyrest-black-xcs" },
      { image: "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/SL_split_lifestyle_1-small.jpg?v=1719340016&width=800", title: "King Koil SmartLife", subtitle: "Smart adjustable sleep", cta: "Shop SmartLife", to: "/mattresses?brand=smartlife" },
    ],
  },
  {
    brand: "King Koil",
    boxes: [
      { image: "/collections/king-koil-natural.jpg", title: "Natural", subtitle: "Natural materials collection", cta: "Shop Natural", to: "/mattresses?q=Natural%20Retreat" },
      { image: "/collections/king-koil-reserve.jpg", title: "Reserve", subtitle: "Premium collection", cta: "Shop Reserve", to: "/mattresses?q=Reserve" },
    ],
  },  {
    brand: "Spring Air",
    boxes: [
      { image: "https://www.springair.com/cdn/shop/files/Copper_ET_Front_Lifestyle_1880x.jpg?v=1747690427", title: "Copper Hybrid", subtitle: "Cooling copper-infused hybrid", cta: "Shop Copper Hybrid", to: "/mattresses?q=Copper%20Hybrid" },
      { image: "https://www.springair.com/cdn/shop/files/Chattam.Palermo_PT_Front_1880x.jpg?v=1749120624", title: "Chattam & Wells", subtitle: "Luxury pillowtop craftsmanship", cta: "Shop Chattam & Wells", to: "/mattresses?q=Chattam" },
    ],
  },  {
    brand: "Puffy & MLILY",
    boxes: [
      { image: "/collections/puffy.jpg", title: "Puffy", subtitle: "Award-winning luxury comfort", cta: "Shop Puffy", to: "/mattresses?brand=puffy" },
      { image: "https://customer-assets-0z36b82j.emergentagent.net/job_mt-modern-retail/artifacts/meygn2qy_FDM_Mattress_MLILY_Landing_Page_Banner_1550x500_ba76f859-ddd9-4224-abac-0803db4faec3.jpg.webp", title: "MLILY", subtitle: "Cooling gel memory foam & hybrids", cta: "Shop MLILY", to: "/mattresses?brand=mlily" },
    ],
  },];

export const INTERIOR_BANNER = {
  image: "/banners/hero-fall-sale.webp",
  alt: "Fall Mattress Sale - Save up to 50% on best-selling mattresses, plus up to 75% off floor models and clearance furniture in stores.",
  to: "/mattresses",
};

export const NAV = [
  {
    label: "Mattresses",
    to: "/mattresses",
    children: [
      { label: "Shop All Mattresses", to: "/mattresses" },
      { label: "Serta", to: "/mattresses?brand=serta" },
      { label: "Beautyrest", to: "/mattresses?brand=beautyrest" },
      { label: "Beautyrest Black", to: "/mattresses?brand=beautyrest-black" },
      { label: "Puffy", to: "/mattresses?brand=puffy" },
      { label: "King Koil", to: "/mattresses?brand=king-koil" },
      { label: "MLILY", to: "/mattresses?brand=mlily" },
      { label: "Spring Air", to: "/mattresses?brand=spring-air" },
      { label: "Simmons", to: "/mattresses?brand=simmons" },
    ],
  },
  { label: "Promotions", to: "/promotions" },
  { label: "Adjustable Bases", to: "/adjustable-bases" },
  { label: "Foundations", to: "/foundations" },
  { label: "Delivery", to: "/services" },
  {
    label: "About",
    to: "/about",
    children: [
      { label: "About Us", to: "/about" },
      { label: "Our Location", to: "/locations" },
      { label: "Video Library", to: "/videos" },
    ],
  },
  { label: "Financing", to: "/financing" },
  { label: "Contact", to: "/contact" },
];

export const SIZES = ["Twin", "Twin XL", "Full", "Queen", "King", "California King"];
export const MOBILE_EXTRA_SIZES = ["Flexhead King", "Split King"];

export const CATEGORIES = [
  {
    slug: "mattresses",
    name: "Mattresses",
    to: "/mattresses",
    image:
      "/products/a1394bd5b4.jpg",
    blurb: "Premium hybrid, memory foam & innerspring mattresses from top brands.",
  },
  {
    slug: "adjustable-bases",
    name: "Adjustable Bases",
    to: "/adjustable-bases",
    image:
      "/assets/gold-lifestyle.webp",
    blurb: "Zero-gravity comfort, massage and app-controlled positioning.",
  },
];

export const BRANDS = [
  {
    slug: "beautyrest-black",
    name: "Beautyrest Black",
    logoText: "Beautyrest Black",
    tagline: "Luxury Hotel Comfort",
    save: "Save up to $1,000",
    accent: "#111111",
    image: "",
    description:
      "Beautyrest Black delivers luxury hotel comfort with advanced pocketed-coil technology and cooling comfort layers for undisturbed, restorative sleep.",
  },
  {
    slug: "beautyrest",
    name: "Beautyrest",
    logoText: "Beautyrest",
    tagline: "Trusted Comfort & Support",
    save: "Up to 70% Off",
    accent: "#14315e",
    image: "",
    description:
      "Beautyrest pairs individually wrapped pocketed coils with plush comfort layers for dependable support and pressure relief at a great value.",
  },
  {
    slug: "serta",
    name: "Serta",
    logoText: "Serta",
    tagline: "The Trusted Name in Sleep",
    save: "Up to 70% Off",
    accent: "#1b6cb3",
    image: "",
    description:
      "The trusted name in sleep, Serta pairs cooling gel memory foam with supportive coils for a balanced, restful night.",
  },
  {
    slug: "serta-perfect-sleeper",
    name: "Serta Perfect Sleeper",
    logoText: "Serta Perfect Sleeper",
    tagline: "Cool, Supportive Sleep",
    save: "Best Seller",
    accent: "#0f4c81",
    image: "",
    description:
      "The Serta Perfect Sleeper collection is engineered for cooler, more supportive sleep with premium gel memory foam and reinforced edge support.",
  },
  {
    slug: "puffy",
    name: "Puffy",
    logoText: "Puffy",
    tagline: "60-Day Home Trial",
    save: "Award-Winning",
    accent: "#1c74d4",
    image: "",
    description:
      "America's #1 award-winning luxury mattress. Try Puffy at home for 60 days - if it's not your perfect match, return it for a full refund. No questions asked.",
  },
  {
    slug: "simmons",
    name: "Simmons",
    logoText: "Simmons",
    tagline: "Beautyrest Heritage",
    save: "Great Value",
    accent: "#111111",
    image: "",
    description:
      "Simmons brings generations of sleep expertise with comfortable, supportive mattresses built for everyday rest at an approachable price.",
  },
  {
    slug: "purebliss",
    name: "PureBliss",
    logoText: "PureBliss",
    tagline: "Natural, Clean Comfort",
    save: "Eco-Friendly",
    accent: "#2f8f83",
    image: "",
    description:
      "PureBliss mattresses feature natural and premium materials for clean, breathable, blissfully comfortable sleep.",
  },
  {
    slug: "smartlife",
    name: "SmartLife",
    logoText: "SmartLife",
    tagline: "Smart Comfort Technology",
    save: "Modern Value",
    accent: "#2a7d5f",
    image: "",
    description:
      "SmartLife delivers modern comfort technology and smart materials that adapt to your body for cool, restful sleep.",
  },
  {
    slug: "king-koil",
    name: "King Koil",
    logoText: "King Koil",
    tagline: "We Bring Sleep Home",
    save: "Save $200",
    accent: "#1b3a6b",
    image: "",
    description:
      "King Koil's Natural Retreat collection blends natural materials with pocketed-coil support for cool, pressure-relieving comfort in every size.",
  },
  {
    slug: "mlily",
    name: "MLILY",
    logoText: "MLILY",
    tagline: "Dream Made Possible",
    save: "Great Value",
    accent: "#e2231a",
    image: "",
    description:
      "MLILY blends advanced gel memory foam, cooling technologies and hybrid support-including the ChiroPro designed with the International Chiropractors Association-for cool, restorative sleep.",
  },
  {
    slug: "spring-air",
    name: "Spring Air",
    logoText: "Spring Air",
    tagline: "Sleep Well. Live Well.",
    save: "Made in USA",
    accent: "#0a4a8f",
    image: "https://www.springair.com/cdn/shop/files/Copper_ET_Front_Lifestyle_1880x.jpg?v=1747690427",
    description:
      "Spring Air has been crafting quality mattresses in America for over 90 years, pairing time-tested support systems with modern cooling comfort. Now available at MattressTown with local delivery, set-up and old-mattress removal.",
  },
];

const LOCAL_PRODUCTS = [
  {
    slug: "beautyrest-black-series-four-apex-16-firm",
    name: 'Beautyrest Black® Series Four Apex Top 16" Hybrid Firm Mattress',
    brand: "beautyrest-black",
    category: "mattresses",
    price: 4349,
    firmness: "Firm",
    height: '16"',
    type: "Hybrid",
    badge: "Top Seller",
    image:
      "/products/a1394bd5b4.jpg",
    gallery: [
      "/products/a1394bd5b4.jpg",
      "/products/3797bf1810.jpg",
    ],
    description:
      "The flagship Beautyrest Black. A 16-inch hybrid with the Apex Top plush comfort system, T3 Pocketed Coil technology and RightTemp cooling for luxurious, undisturbed sleep.",
    features: ["T3 Pocketed Coil® Technology", "RightTemp™ Max cooling cover", "Apex Top plush layer", "16-inch profile"],
  },
  {
    slug: "beautyrest-black-series-four-apex-16-plush",
    name: 'Beautyrest Black® Series Four Apex Top 16" Hybrid Plush Mattress',
    brand: "beautyrest-black",
    category: "mattresses",
    price: 4349,
    firmness: "Plush",
    height: '16"',
    type: "Hybrid",
    image:
      "/products/3797bf1810.jpg",
    gallery: [
      "/products/3797bf1810.jpg",
    ],
    description:
      "Sink into cloud-like comfort with the plush Apex Top and advanced coil support of the Beautyrest Black Series Four.",
    features: ["T3 Pocketed Coil® Technology", "RightTemp™ Max cooling", "Extra plush pillow top", "16-inch profile"],
  },
  {
    slug: "beautyrest-black-series-one-12-5-firm",
    name: 'Beautyrest Black® Series One 12.5" Hybrid Firm Mattress',
    brand: "beautyrest-black",
    category: "mattresses",
    price: 1549,
    firmness: "Firm",
    height: '12.5"',
    type: "Hybrid",
    badge: "Best Value",
    image:
      "/products/4e26cbaa0f.jpg",
    gallery: [
      "/products/4e26cbaa0f.jpg",
    ],
    description:
      "An accessible entry into Beautyrest Black luxury. Firm hybrid support with pocketed coils and cooling comfort foam.",
    features: ["Pocketed Coil® support", "Cooling comfort foam", "Firm support feel", "12.5-inch profile"],
  },
  {
    slug: "beautyrest-black-series-one-12-5-plush",
    name: 'Beautyrest Black® Series One 12.5" Hybrid Plush Mattress',
    brand: "beautyrest-black",
    category: "mattresses",
    price: 1749,
    firmness: "Plush",
    height: '12.5"',
    type: "Hybrid",
    image:
      "/products/90a268418c.jpg",
    gallery: [
      "/products/90a268418c.jpg",
    ],
    description:
      "Plush pressure relief meets dependable hybrid support in the Beautyrest Black Series One.",
    features: ["Pocketed Coil® support", "Plush comfort foam", "Cooling cover", "12.5-inch profile"],
  },
  {
    slug: "beautyrest-black-series-three-15-medium",
    name: 'Beautyrest Black® Series Three 15" Hybrid Medium Mattress',
    brand: "beautyrest-black",
    category: "mattresses",
    price: 3449,
    firmness: "Medium",
    height: '15"',
    type: "Hybrid",
    image:
      "/products/a84da79b0a.jpg",
    gallery: [
      "/products/a84da79b0a.jpg",
    ],
    description:
      "A balanced medium feel with premium cooling and advanced coil support for all sleep positions.",
    features: ["T2 Pocketed Coil® Technology", "RightTemp™ cooling", "Medium balanced feel", "15-inch profile"],
  },
  {
    slug: "beautyrest-world-class-level-3-medium",
    name: 'Beautyrest World Class Hybrid Level 3 Medium 13" Mattress',
    brand: "beautyrest",
    category: "mattresses",
    price: 1299,
    firmness: "Medium",
    height: '13"',
    type: "Hybrid",
    badge: "Great Deal",
    image:
      "/products/7613940543.jpg",
    gallery: [
      "/products/7613940543.jpg",
    ],
    description:
      "Reliable comfort and support at an unbeatable value. Individually wrapped coils with balanced medium comfort.",
    features: ["Pocketed Coil® support", "Gel memory foam", "Medium feel", "13-inch profile"],
  },
  {
    slug: "beautyrest-world-class-level-4-medium-pillowtop",
    name: 'Beautyrest World Class Level 4 Medium Apex Top 14" Pillow Top',
    brand: "beautyrest",
    category: "mattresses",
    price: 1799,
    firmness: "Medium",
    height: '14"',
    type: "Hybrid Pillow Top",
    image:
      "/products/420ba8dc87.jpg",
    gallery: [
      "/products/420ba8dc87.jpg",
    ],
    description:
      "A plush pillow-top hybrid delivering cushioned comfort with dependable coil support.",
    features: ["Apex pillow top", "Pocketed Coil® support", "Cooling foam", "14-inch profile"],
  },
  {
    slug: "puffy-lux-hybrid",
    name: "Puffy Lux Hybrid Mattress",
    brand: "puffy",
    category: "mattresses",
    price: 1699,
    firmness: "Medium",
    height: '12"',
    type: "Hybrid",
    badge: "101-Night Trial",
    image:
      "/products/a1394bd5b4.jpg",
    gallery: [
      "/products/a1394bd5b4.jpg",
    ],
    description:
      "America's #1 award-winning luxury mattress. Cloud-like memory foam over supportive coils, backed by a 60-day home trial and lifetime warranty.",
    features: ["Cooling Cloud™ foam", "Contour-Adapt coils", "60-day home trial", "Lifetime warranty"],
  },
  {
    slug: "puffy-cloud-mattress",
    name: "Puffy Cloud Mattress",
    brand: "puffy",
    category: "mattresses",
    price: 1149,
    firmness: "Medium",
    height: '10"',
    type: "Memory Foam",
    image:
      "/products/211bcc8683.jpg",
    gallery: [
      "/products/211bcc8683.jpg",
    ],
    description:
      "The original award-winning Puffy. Pressure-relieving memory foam that keeps you cool and cradled all night.",
    features: ["Cooling Cloud™ foam", "ClimateComfort™ layer", "Stain-resistant cover", "101-night trial"],
  },
  {
    slug: "serta-perfect-sleeper-medium",
    name: "Serta Perfect Sleeper Cobalt Calm 13.5\" Medium Hybrid",
    brand: "serta",
    category: "mattresses",
    price: 999,
    firmness: "Medium",
    height: '13.5"',
    type: "Hybrid",
    badge: "Best Seller",
    image:
      "/products/90a268418c.jpg",
    gallery: [
      "/products/90a268418c.jpg",
    ],
    description:
      "Cooling gel memory foam paired with a supportive coil system for balanced, restful sleep at a great price.",
    features: ["Cooling gel memory foam", "Supportive coil system", "Medium feel", "13.5-inch profile"],
  },
  {
    slug: "serta-icomfort-firm",
    name: "Serta iComfort Foam 11\" Firm Mattress",
    brand: "serta",
    category: "mattresses",
    price: 1199,
    firmness: "Firm",
    height: '11"',
    type: "Memory Foam",
    image:
      "/products/b2ddd9243f.jpg",
    gallery: [
      "/products/b2ddd9243f.jpg",
    ],
    description:
      "Advanced temperature management foam with firm, supportive comfort for back and stomach sleepers.",
    features: ["Carbon fiber cooling", "EverCool® foam", "Firm support", "11-inch profile"],
  },
  {
    slug: "adjustable-base-premier",
    name: "MattressTown Premier Adjustable Base",
    brand: "bedtech",
    category: "adjustable-bases",
    price: 999,
    firmness: "-",
    height: '-',
    type: "Adjustable Base",
    badge: "Popular",
    image:
      "/products/premier-adjustable-base.jpg",
    gallery: [
      "/products/premier-adjustable-base.jpg",
    ],
    description:
      "Head-and-foot articulation, zero-gravity preset, full-body massage and wireless remote for personalized comfort.",
    features: ["Zero-gravity preset", "Full-body massage", "Wireless remote", "USB charging ports"],
  },
];

const CITY_BRANDS = new Set([
  "beautyrest-black",
  "beautyrest",
  "serta",
  "serta-perfect-sleeper",
  "sealy",
  "simmons",
  "puffy",
  "smartlife",
  "king-koil",
]);

const LOCAL_PRODUCT_ALLOWLIST = new Set([
  "beautyrest-world-class-level-3-medium",
  "beautyrest-world-class-level-4-medium-pillowtop",
]);

const EXCLUDED_BRANDS = new Set(["sealy", "tempur", "tempur-pedic", "stearns", "stearns-foster", "bedtech"]);

export const PRODUCTS = [
  ...ADJUSTABLE_CATALOG,
  ...FOUNDATIONS_CATALOG,
  ...CATALOG,
  ...EXTRA_CATALOG,
  ...MLILY_CATALOG,
  ...SERTA_KK_EXTRA_CATALOG,
  ...SPRINGAIR_CATALOG,
  ...CATALOG_2026,
  ...LOCAL_PRODUCTS.filter((p) => !CITY_BRANDS.has(p.brand) || LOCAL_PRODUCT_ALLOWLIST.has(p.slug)),
].filter((p) => !EXCLUDED_BRANDS.has((p.brand || "").toLowerCase()));

export const REVIEWS = [
  { name: "Denise Michel", date: "Jul 6, 2025", rating: 5, text: "Great service and great prices! Steven was amazing. Thank you so very much for your assistance!" },
  { name: "Cody Carson", date: "Jul 5, 2025", rating: 5, text: "John was super helpful and friendly, gave us a great deal and scheduled delivery very quickly over a holiday weekend. Quality name brand mattresses." },
  { name: "Daniel Novella", date: "Jul 5, 2025", rating: 5, text: "John helped me find the perfect bed with awesome discounts. It's a family business so you're treated like family. Highly recommend." },
  { name: "Jhonatan Ospina", date: "Jul 2, 2025", rating: 5, text: "Great price, great customer service! Highly recommend!" },
  { name: "Mike Tinley", date: "Jun 25, 2025", rating: 5, text: "Had to replace my mattress after 1.5 years. Steven did the swap out same day. Great job." },
  { name: "Nadege Desforges", date: "Jun 24, 2025", rating: 5, text: "The best experience buying a mattress here - very knowledgeable and generous with their time." },
];

export const SERVICES = [
  { icon: "Truck", title: "Same-Day Delivery", desc: "Order today and get set up fast. Local delivery is available across Fort Lauderdale and Broward County." },
  { icon: "Wrench", title: "Set-Up & Removal", desc: "Our team can assemble your new bed and haul away your old mattress. Ask about delivery and setup options." },
  { icon: "CreditCard", title: "Special Financing", desc: "Flexible financing options with quick approval so you can pay over time. Ask an associate for details." },
  { icon: "Moon", title: "60-Day Comfort Guarantee", desc: "Try select mattresses at home. If it's not your perfect match, we'll make it right." },
  { icon: "BadgeCheck", title: "60-Day Price Guarantee", desc: "Found it cheaper? We'll match honest, advertised prices from authorized retailers." },
  { icon: "Headphones", title: "Expert Sleep Guidance", desc: "Family-owned and operated. Our specialists help you find the perfect fit - no pressure." },
];

// SEO city / community landing pages
export const CITY_PAGES = [
  {
    slug: "fort-lauderdale",
    city: "Fort Lauderdale",
    county: "Broward County",
    intro:
      "MattressTown is Fort Lauderdale's trusted local mattress store, proudly serving the community from our showroom on N Federal Highway with premium brands and honest pricing.",
    neighborhoods: ["Victoria Park", "Wilton Manors", "Coral Ridge", "Las Olas", "Oakland Park", "Poinsettia Heights"],
  },
  {
    slug: "oakland-park",
    city: "Oakland Park",
    county: "Broward County",
    intro:
      "Looking for a mattress store near Oakland Park? MattressTown is just minutes away on N Federal Highway with a full showroom of top brands and delivery to Oakland Park homes.",
    neighborhoods: ["Coral Heights", "Lloyd Estates", "North Andrews Gardens", "Twin Lakes"],
  },
  {
    slug: "wilton-manors",
    city: "Wilton Manors",
    county: "Broward County",
    intro:
      "MattressTown proudly serves Wilton Manors with premium mattresses, adjustable bases and same-day delivery from our nearby Fort Lauderdale showroom.",
    neighborhoods: ["Central Area", "Five Points", "Manor Isles"],
  },
  {
    slug: "pompano-beach",
    city: "Pompano Beach",
    county: "Broward County",
    intro:
      "Shopping for a new mattress in Pompano Beach? Visit MattressTown's Fort Lauderdale showroom for luxury brands, expert guidance and delivery throughout Pompano Beach.",
    neighborhoods: ["Cresthaven", "Palm Aire", "Cypress Bend", "Harbor Village"],
  },
];

export const ACCESSIBILITY_STATEMENT = {
  updated: "February 27, 2026",
  sections: [
    {
      heading: "Our Commitment to Accessibility",
      body: [
        "We are committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying relevant accessibility standards to enhance usability and inclusivity.",
        "Our goal is to provide a website that is accessible to the widest possible audience, regardless of technology or ability.",
      ],
    },
    {
      heading: "Accessibility Standards",
      body: [
        "We strive to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA, which are widely recognized as the industry standard for website accessibility.",
        "Accessibility is an ongoing process, and we are actively working toward improving the accessibility and usability of our website.",
      ],
    },
    {
      heading: "Accessibility Technology & Tools",
      body: [
        "To support our accessibility efforts, we have deployed industry-standard accessibility technology designed to enhance usability and assist visitors with disabilities. These tools may provide features such as:",
      ],
      list: [
        "Screen reader enhancements",
        "Keyboard navigation improvements",
        "Color contrast adjustments",
        "Text size and spacing controls",
        "Focus indicators",
        "Additional accessibility interface options",
      ],
      after: [
        "This technology helps us improve accessibility while we continue broader auditing, remediation, and development efforts.",
      ],
    },
    {
      heading: "Ongoing Improvement",
      body: ["Accessibility is an ongoing initiative. We are:"],
      list: [
        "Reviewing site content and functionality regularly",
        "Working with developers and accessibility tools",
        "Identifying and remediating barriers",
        "Incorporating accessibility into future design and development",
      ],
      after: [
        "We understand accessibility is a continuous journey and are committed to making improvements over time.",
      ],
    },
    {
      heading: "Third-Party Content",
      body: [
        "Some areas of the website may include third-party content, plugins, or integrations that are not fully controlled by us.",
        "While we encourage vendors to provide accessible content, we cannot guarantee accessibility of third-party features. However, we welcome feedback regarding any issues encountered.",
      ],
    },
    {
      heading: "Feedback & Assistance",
      body: [
        "If you experience difficulty accessing any part of this website, need assistance, or would like to request content in an alternative format, please contact us. Please include:",
      ],
      list: ["The page URL", "Description of the issue", "Your preferred contact method"],
      after: [
        "Contact: Information on our Contact Us page. We aim to respond within a reasonable timeframe and will make reasonable efforts to provide accessible alternatives.",
      ],
    },
    {
      heading: "Good Faith Efforts",
      body: [
        "We are making good-faith efforts to comply with accessibility standards and improve usability for individuals with disabilities. Despite our efforts, some content may not yet fully meet the strictest accessibility standards due to the evolving nature of technology and ongoing updates.",
        "We appreciate your understanding as we continue improving accessibility.",
      ],
    },
    {
      heading: "Terms & Conditions - Accessibility Clause",
      body: [
        "We are committed to providing an accessible website experience for all users and strive to follow recognized accessibility standards, including WCAG guidelines.",
        "We have implemented industry-standard accessibility tools and continue to review, update, and improve our website to enhance accessibility.",
        "Because accessibility is an ongoing process, some areas of the website may not yet fully conform to all accessibility standards.",
        "If you encounter accessibility barriers, please contact us so we can provide assistance, offer alternative access, and address the issue where feasible.",
        "Nothing in these Terms is intended to limit any rights available under applicable accessibility laws.",
      ],
    },
  ],
};

export const FAQS = [
  {
    q: "Where is MattressTown located?",
    a: "MattressTown is located at 2677 N Federal Hwy, Fort Lauderdale, FL 33306. We proudly serve Fort Lauderdale and all of Broward County.",
  },
  {
    q: "Do you offer mattress delivery?",
    a: "Yes, we offer local delivery across Fort Lauderdale and Broward County, plus professional set-up and old-mattress removal. Ask an associate for delivery details and pricing.",
  },
  {
    q: "Which mattress brands do you carry?",
    a: "We carry premium name brands including Beautyrest Black, Beautyrest World Class, Puffy and Serta, with mattresses to fit every comfort preference and budget.",
  },
  {
    q: "What are your showroom hours?",
    a: "Our showroom is open Monday through Friday from 10:00 AM to 7:00 PM, and Saturday and Sunday from 11:00 AM to 6:00 PM.",
  },
  {
    q: "Do you offer financing?",
    a: "Yes, we offer special financing options with quick approval so you can pay over time. Ask one of our associates in the showroom or call us for details.",
  },
];

export const HERO_IMAGE =
  "/assets/gold-lifestyle.webp";
export const EXPERT_IMAGE =
  "/products/73a1b92ac7.jpg";

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
export const getBrand = (slug) => BRANDS.find((b) => b.slug === slug);
export const getCity = (slug) => CITY_PAGES.find((c) => c.slug === slug);
export const productsByBrand = (slug) => PRODUCTS.filter((p) => p.brand === slug);
export const productsByCategory = (slug) => PRODUCTS.filter((p) => p.category === slug);
